import { ContextFormByIdProvider, IContextFormByIdBeforeMount } from "@ngt/forms";
import { FC, PropsWithChildren, useMemo } from "react";
import { useParams } from "react-router-dom";
import { FormDefinitions, Lot } from "../../api/dtos";

export interface ILotFormByIdRouteProps extends PropsWithChildren {
    lotId?: number | undefined;

    loadBeforeMount?: boolean | IContextFormByIdBeforeMount;
    validateBeforeMount?: boolean | IContextFormByIdBeforeMount;
}

const LotFormByIdRoute: FC<ILotFormByIdRouteProps> = ({
    lotId,
    loadBeforeMount,
    validateBeforeMount,
    children
}) => {
    const params = useParams();

    const lotIdToUse = (params.lotId ? +params.lotId : undefined) ?? lotId ?? undefined;

    const stageId = params.stageId ? +params.stageId : undefined;

    const createData = useMemo(() => new Lot({
        stageId
    }), [stageId]);

    return (
        <ContextFormByIdProvider
            formId={lotIdToUse}
            formDefinitionIdentifier={FormDefinitions.Lot}
            createData={createData}

            loadBeforeMount={loadBeforeMount}
            //LoadingComponent={RouteLoading}

            validateBeforeMount={validateBeforeMount}
            //ValidatingComponent={RouteLoading}
        >
            {children}
        </ContextFormByIdProvider>
    );
}

export default LotFormByIdRoute;
